import React, { useState, useRef, useLayoutEffect } from "react";
import ReactDOM from "react-dom";

interface TooltipProps {
  content: string;
  children: React.ReactNode;
  position?: "top" | "bottom" | "left" | "right" | "topleft";
}

const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  position = "topleft",
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [coords, setCoords] = useState<{ top: number; left: number } | null>(
    null
  );
  const triggerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (isVisible && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      // 计算左上角
      setCoords({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
      });
    }
  }, [isVisible]);

  // Portal内容
  const tooltipNode =
    isVisible && coords
      ? ReactDOM.createPortal(
          <div
            className="z-[9999] px-2 py-1 text-xs text-white bg-green-600 rounded shadow-lg whitespace-nowrap fixed"
            style={{
              top: coords.top - 36, // 上方偏移
              left: coords.left,
            }}
          >
            {content}
            {/* 箭头 */}
            <div
              className="absolute left-2 top-full w-2 h-2 bg-green-600 transform rotate-45"
              style={{ marginTop: "-4px" }}
            />
          </div>,
          document.body
        )
      : null;

  return (
    <div
      className="relative inline-block"
      ref={triggerRef}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {tooltipNode}
    </div>
  );
};

export default Tooltip;
